interface PostIdentity {
  userId?: string | number | null;
  username?: string | null;
  authorId?: string | number | null;
  profileUserGuid?: string | null;
}

interface CurrentUserIdentity {
  id?: string | number | null;
  userId?: number | string | null;
  name?: string | null;
  userName?: string | null;
  userGuid?: string | null;
  userGUID?: string | null;
}

const normalizeIdentity = (value: string | number | null | undefined): string =>
  value == null ? '' : String(value).trim().toLowerCase();

/** Returns true when the post belongs to either the profile or auth identity. */
export const isPostOwnedByUser = (
  post?: PostIdentity | null,
  profile?: CurrentUserIdentity | null,
  authIdentity?: CurrentUserIdentity | null,
): boolean => {
  if (!post || (!profile && !authIdentity)) {
    return false;
  }

  const postIds = [post.userId, post.authorId, post.profileUserGuid]
    .map(normalizeIdentity)
    .filter(Boolean);
  const currentUserIds = [
    profile?.userId,
    profile?.id,
    profile?.userGuid,
    profile?.userGUID,
    authIdentity?.userId,
    authIdentity?.id,
    authIdentity?.userGuid,
    authIdentity?.userGUID,
  ]
    .map(normalizeIdentity)
    .filter(Boolean);

  if (postIds.length > 0 && currentUserIds.length > 0) {
    return postIds.some(id => currentUserIds.includes(id));
  }

  const postUsername = post.username?.trim().toLowerCase();
  const currentNames = [
    profile?.userName,
    profile?.name,
    authIdentity?.userName,
    authIdentity?.name,
  ]
    .map(name => name?.trim().toLowerCase())
    .filter((name): name is string => Boolean(name));

  return Boolean(postUsername && currentNames.includes(postUsername));
};
